const isEmpty = (value?: string) => !value || !value.trim();
const required = (value?: string) =>
  isEmpty(value) ? 'Поле обязательно для заполнения' : undefined;
const maxLength = (value: string | undefined, max: number) =>
  isEmpty(value) ? undefined : value!.trim().length <= max ? undefined : `Максимум ${max} символов`;
const minLength = (value: string | undefined, min: number) =>
  isEmpty(value) ? undefined : value!.trim().length >= min ? undefined : `Минимум ${min} символа`;
const normalizeDigits = (value?: string) => (value ?? '').replace(/\D/g, '');
const digitsOnly = (value: string | undefined) =>
  isEmpty(value) ? undefined : /^\d+$/.test(value!.trim()) ? undefined : 'Допустимы только цифры';
const maxDigits = (value: string | undefined, max: number) =>
  isEmpty(value) ? undefined : normalizeDigits(value).length <= max ? undefined : `Максимум ${max} символов`;
const emailFormat = (value: string | undefined) =>
  isEmpty(value) ? undefined : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value!.trim()) ? undefined : 'Некорректный email';

const isValidRequiredText = (value?: string, min?: number, max?: number) => {
  if (required(value)) {
    return false;
  }
  if (typeof min === 'number' && minLength(value, min)) {
    return false;
  }
  if (typeof max === 'number' && maxLength(value, max)) {
    return false;
  }
  return true;
};
const isValidOptionalText = (value?: string, max?: number) => {
  if (isEmpty(value)) {
    return true;
  }
  return typeof max === 'number' ? !maxLength(value, max) : true;
};

const isValidRequiredDigits = (value: string | undefined, max: number) =>
  !required(value) && !digitsOnly(value) && !maxDigits(value, max);
const isValidOptionalDigits = (value: string | undefined, max: number) =>
  isEmpty(value) ? true : !digitsOnly(value) && !maxDigits(value, max);

const isValidRequiredEmail = (value: string | undefined, max: number) =>
  !required(value) && !emailFormat(value) && !maxLength(value, max);
const isValidOptionalEmail = (value: string | undefined, max: number) =>
  isEmpty(value) ? true : !emailFormat(value) && !maxLength(value, max);

export {
  digitsOnly,
  emailFormat,
  isEmpty,
  isValidOptionalDigits,
  isValidOptionalEmail,
  isValidOptionalText,
  isValidRequiredDigits,
  isValidRequiredEmail,
  isValidRequiredText,
  maxDigits,
  maxLength,
  minLength,
  required,
};
